export default {
      id: "observation-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#observation",
      toString: function () {
        return this.url;
      }
    }